// extracted by mini-css-extract-plugin
module.exports = {"mobile":"styles_mobile__dvl11"};